export default {
  exemptionTotal(state, total) {
    return (state.exemptionTotal = total);
  },
  exemptionApprovalTotal(state, total) {
    return (state.exemptionApprovalTotal = total);
  },
  searchQuery(state, value) {
    return (state.searchQuery = value);
  },
  tableLoader(state, value) {
    return (state.tableLoading = value);
  },
  currentPage(state, value) {
    return (state.currentPage = value);
  },
  perPage(state, value) {
    return (state.perPage = value);
  },
  employees(state, value) {
    return (state.employees = value);
  },
  exemptionsData(state, value) {
    return (state.exemptionsData = value);
  },
  currentExemption(state, value) {
    return (state.currentExemption = value);
  },
  employeeExemption(state, value) {
    return (state.employeeExemption = value);
  },
  approvals(state, value) {
    return (state.approvals = value);
  },
  currentApproval(state, value) {
    return (state.currentApproval = value);
  },
  filterValue(state, value) {
    return (state.filterValue = value);
  },
  filterDate(state, value) {
    return (state.filterDate = value);
  },
  exemptionApproval(state, value) {
    return (state.exemptionApproval = value);
  },
};
